export const fileToBase64 = (file: File, generatePureBase64: boolean = false): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      if (generatePureBase64) {
        const pureBase64String = (fileReader.result as string).split(',')[1];
        resolve(pureBase64String as string);
      }
      resolve(fileReader.result as string);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
